import { useQuery } from "@tanstack/react-query";

import { fetchJson } from "@/dashboard/hooks/api/fetch-json";
import { isHttpError } from "@/dashboard/lib/api/errors";
import type { Tenant } from "@/dashboard/types/tenant";
import type { User } from "@/dashboard/types/user";

export interface MeResponse {
  user: User;
  tenants: Tenant[];
  activeTenantId: string;
  isSelfServe: boolean;
}

export function useMeQuery() {
  return useQuery<MeResponse>({
    queryKey: ["me"],
    queryFn: () => fetchJson("/api/dashboard/session", { cache: "no-store" }),
    staleTime: 5 * 60_000,
    retry: (failureCount, err: unknown) =>
      isHttpError(err)
        ? err.status !== 401 && failureCount < 3 // do not retry 401
        : failureCount < 3,
  });
}
